import React, { useEffect, useState } from 'react';
import Wrapper from '../Wrapper';
import AddCources from './AddCources';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import Input from '../../components/Input';

const Cources = () => {
  const [course, setCourse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [students, setStudents] = useState({});
  const [selectedCategory, setSelectedCategory] = useState('');

  const categoryFun = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/category', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setCategory(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const studentDetails = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/total-students', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setStudents(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    categoryFun();
    studentDetails();
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/user/course', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setCourse(data?.courses);
        setLoading(false);
      })
      .catch((error) => console.error(error));
  }, []);

  const [open, setOpen] = useState(false);

  const filteredCourses = course?.filter((course) => {
    const matchesSearchQuery = course?.name?.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory ? course.category === selectedCategory : true;
    return matchesSearchQuery && matchesCategory;
  });

const handleDeleteCourse = (courseId) => {
  if (window.confirm('Are you sure you want to delete this course?')) {
    fetch(`https://quran-backend-theta.vercel.app/v1/admin/course/${courseId}`, {
      method: 'DELETE'
    })
    .then(response => {
      if (response.ok) {
        // Remove course from local state to update UI immediately
        setCourse(prev => prev.filter(course => course._id !== courseId));
        alert('Course deleted successfully');
      } else {
        throw new Error('Delete failed');
      }
    })
    .catch(error => {
      console.error('Delete error:', error);
      alert('Failed to delete course');
    });
  }
};

  return (
    <Wrapper
      searchBar={
        <Input
          placeholder={`Search by course name...`}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <AddCources setIsModalOpen={setOpen} isModalOpen={open} />
      <div className=" flex justify-between items-center ">
        <div>
          <h2 className="main_title ">Cources</h2>
          <p className=" text-[#1C1D1D]">Here overview of the courses</p>
        </div>
        {/* <div className="cursor-pointer">
          <img onClick={() => setOpen(true)} src={require('../../assets/image/add.png')} alt="" />
        </div> */}
      </div>

      <section className=" pt-2">
        <div className=" py-4  w-full grid  grid-cols-1  xl:grid-cols-3 md:grid-cols-2 gap-5">
          <div className=" w-full">
            <div
              className="  bg-white p-5 rounded-lg flex  justify-between"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Enrolled Students</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3  text-[#1C1D1D]">{students?.totalEnrolled}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/active.png')} alt="" />
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div
              className=" bg-white  flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Ongoing Courses</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{students?.approved}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/ongoing.png')} alt="" />
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div
              className=" bg-white  text-black flex justify-between p-5 rounded-lg"
              style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
            >
              <div>
                <h2 className=" text-[#1C1D1D] text-[20px] font-semibold">Completed</h2>
                <div className=" pt-2 flex items-center gap-3">
                  <p className="text-lg pt-3 text-black">{students?.completed}</p>
                </div>
              </div>
              <div>
                <img src={require('../../assets/image/completed.png')} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="w-full pb-7">
        <label className="block mb-2 text-sm text-gray-900 font-medium">Filter By Category</label>
        <select
          name="category"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="w-full py-3 outline-none  bg-white shadow-lg p-2.5 text-black placeholder:text-primary rounded-md"
        >
          <option value="">Select Category</option>
          {category?.map((item, index) => (
            <option key={index} value={item?._id}>
              {item?.name}
            </option>
          ))}
        </select>
      </div>

      <section>
        {loading ? (
          <Loader /> // Show the loader while fetching courses
        ) : (
          <>
            {filteredCourses && filteredCourses.length > 0 ? (
              <>
                {filteredCourses.map((course) => (
                  <div className="grid grid-cols-1 mt-4 gap-6 relative" key={course._id}>
                    <div
                      className="bg-white flex md:flex-row flex-col rounded-lg gap-4"
                      style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                    >
                      <div className="md:w-3/12 w-full">
                        <Link to={`/cources-details/${course?._id}`} className="block h-full">
                          <img
                            src={course?.image}
                            className="w-full h-64 object-cover rounded-lg"
                            alt=""
                          />
                        </Link>
                      </div>

                      <div className="md:w-8/12 w-full p-4 relative">
                        {/* Delete Button - Now more prominent */}
                        <button
                          onClick={() => handleDeleteCourse(course._id)}
                          className="absolute top-4 right-4 bg-red-500 hover:bg-red-600 text-red p-2 rounded-md shadow-lg flex items-center gap-1 z-10"
                          style={{ minWidth: '100px' }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span>Delete</span>
                        </button>

                        <div className="pr-16"> {/* Added padding to prevent text overlap */}
                          <Link to={`/cources-details/${course?._id}`} className="block">
                            <h6 className="pt-3 text-lg font-semibold">{course?.name}</h6>
                            <div className="flex gap-5 pt-2 items-center">
                              <div className="flex gap-1 items-center">
                                <div>
                                  <img src={require('../../assets/image/Form.png')} alt="" />
                                </div>
                                <p>{course?.lesson} Lesson</p>
                              </div>

                              <div className="flex gap-1 items-center">
                                <div>
                                  <img src={require('../../assets/image/Graduation Cap.png')} alt="" />
                                </div>
                                <p>{course?.duration}</p>
                                <p>{course?.periodType}</p>
                              </div>
                            </div>
                            <p className="pt-2 text-sm text-gray-600">{course?.description}</p>
                            <div className="flex items-center gap-2 pt-3">
                              <img src={require('../../assets/image/Form.png')} alt="" />
                              <p>121 Students</p>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <>
                <div className="text-center mt-8">
                  <p className="text-gray-600 text-lg">No courses available at the moment.</p>
                </div>
              </>
            )}
          </>
        )}
      </section>
    </Wrapper>
  );
};

export default Cources;